import React, { useEffect } from "react";
import { insuranceServices } from "../../../../api/services/insuranceServices";
import { loanService } from "../../../../api/services/loanService";
import { useAppSelector } from "../../../../infra/hooks";

interface PropsValue {
  setAllInsurerTypesData: (data: any) => void;
  setAllPolicyTypesData: (data: any) => void;
}
const DTOEditInsurance = ({
  setAllInsurerTypesData,
  setAllPolicyTypesData,
}: PropsValue) => {
  const selector = useAppSelector((state) => state.authSlice);

  async function getAllInsurers(companyId: number) {
    const response: any = await insuranceServices.getInsurers(companyId);
    if (response) {
      setAllInsurerTypesData(response?.data);
    }
  }
  async function getAllPolicyTypes(companyId: number) {
    const response: any = await insuranceServices.getPolicies(companyId);
    if (response) {
      setAllPolicyTypesData(response?.data);
    }
  }

  useEffect(() => {
    if (selector?.company_id) {
      getAllInsurers(selector.company_id);
      getAllPolicyTypes(selector.company_id);
    }
  }, []);

  return <></>;
};

export default DTOEditInsurance;
